import { QuestionType } from '../enums/question.type.enum';

export class Question {
    id: string;
    name: string;
    number: number;
    type: QuestionType;
    questionGroupId: string;
    enabled: boolean;
    isPolitical: boolean;
    isCommercial: boolean;
    filename: string;
    fileEditDate: string;
    title: string;
    questionText: string;
    description: string;
    externalLink: string;
    answer1: string;
    answer2: string;
    answer3: string;
    validNumber: number;
   constructor() {
   }
}



// WEBPACK FOOTER //
// ./src/app/models/question.model.ts